export async function tienePushActivo() {
  if (!("serviceWorker" in navigator)) return false;

  try {
    const reg = await navigator.serviceWorker.ready;

    const sub = await reg.pushManager.getSubscription();

    return !!sub;
  } catch (e) {
    console.warn("Error verificando push:", e);
    return false;
  }
}